import { Component, OnInit, OnDestroy } from '@angular/core';

import { QuoteModel } from '../../models/quote.model';
import { QuoteService } from '../../services/quote.service';
import { CustomerModel } from '../../models/customer.model';
import { CustomerService } from '../../services/customer.service';

import { IMyDpOptions } from 'mydatepicker';

import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { PackService } from '../../services/pack.service';
import { ApiService } from '../../services/api.service';
import { BikeService2 } from '../../services/bike2.service';
import { ArticleModel } from '../../models/article.model';
import { MagasinService } from '../../services/magasin.service';
import {InvoiceService} from '../../services';
import {InvoiceModel} from '../../models';

@Component({
    selector   : 'my-quote',
    template: require('./quote.component.html'),
    styles: [require('./quote.component.scss')]
})
export class QuoteComponent implements OnInit, OnDestroy {

    buttonsNew: any;
    buttonsLoad: any;
    quote: QuoteModel;
    customerPrivateId: string;
    customer: CustomerModel;

    listModal: any = {
        'generalError': false,
        'delete'      : false,
        'archive'     : false,
        'unarchive'   : false
    };

    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd.mm.yyyy',
        editableDateField: false,
        showInputField: true,
    };


    constructor(public magasinService:MagasinService,
                public invoiceService: InvoiceService,
                public bikeService2: BikeService2, public packService: PackService, public quoteService: QuoteService, public customerService: CustomerService, private route: ActivatedRoute, private router: Router, private apiService: ApiService) {
        this.customer = new CustomerModel(customerService);
        this.quote  = new QuoteModel(quoteService);
        this.packService.loadAll();

        this.buttonsNew = {
            'left'  : [],
            'center': [
                {'title'    : 'retour au client',
                    'style' : 'primary',
                    'action': 'returnCustomer',
                    'model' : this,
                    'icon'  : 'fa-arrow-left'
                }
            ],
            'right' : [],
        };

        this.buttonsLoad = {
            'left'  : [
                {'title': 'Imprimer', 'style': 'primary', 'action': 'download', 'model': this, 'icon': 'fa-download'}
            ],
            'center': [
                {'title'    : 'retour au client',
                    'style' : 'primary',
                    'action': 'returnCustomer',
                    'model' : this,
                    'icon'  : 'fa-arrow-left'
                },
                {'title'    : 'transformer en facture',
                    'style' : 'primary',
                    'action': 'toBill',
                    'model' : this,
                    'icon'  : 'fa-money'
                }
            ],
            'right' : [
                {'title'    : 'dupliquer',
                    'style' : 'secondary',
                    'action': 'duplicate',
                    'model' : this,
                    'icon'  : 'fa-files-o'
                },
                {'title': 'supprimer', 'style': 'secondary', 'action': 'openDelete', 'model': this, 'icon': 'fa-trash'},
            ],
        };
    }

    ngOnInit() {
        console.log('init quote component')
        this.route.params.subscribe(params=> {
            this.customerPrivateId = params['customerPrivateId'];
            this.bikeService2.getAll(this.customerPrivateId);
            if (params['quotePrivateId']) {
                if (params['duplicate']) {
                    //load une facture
                    this.duplicate(params['quotePrivateId']);
                } else {
                    //load une facture
                    this.loadQuote(params['quotePrivateId']);
                }
            } else {
                //nouvelle facture
                this.loadNewQuote();
            }
        });
    }

    onDateChanged(_event: any){
        this.quote.modelChange(null);
    }

    openDelete() {
        this.listModal['delete'] = true;
    }

    openArchive() {
        if (this.quote.archive)
            this.listModal['unarchive'] = true;
        else
            this.listModal['archive'] = true;
    }

    download() {
        this.apiService.quotePdf(this.quote.privateId);
    }

    duplicate(quotePrivateId: string) {
        if (!quotePrivateId)
            quotePrivateId = this.quote.privateId;
        if (!this.quote.privateId || this.quote.validate()) {
            this.quoteService.duplicate(quotePrivateId, this.quote, true);
        }
    }

    loadQuote(quotePrivateId: string) {
        this.quote.articles = [];
        this.quoteService.load(quotePrivateId, this.quote);
    }

    loadNewQuote() {
        this.quoteService.loadCustomer(this.customerPrivateId, this.quote);
        this.quote.clientPrivateId = this.customerPrivateId;
        this.quote.generatePublicId();
        this.quote.addArticle();

        let d                  = new Date();
        this.quote.whenDay   = d.getDate();
        this.quote.whenMonth = d.getMonth() + 1;
        this.quote.whenYear  = d.getFullYear();

        this.quote.where = this.magasinService.current;
        this.quote.magasin = this.magasinService.current;
    }

    addBike(bike) {
        let tmp  = new ArticleModel(this.quote);
        tmp.bike = bike;
        tmp.type = 1;

        this.quote.articles.push(tmp);
        this.quote.state = 3;
    }

    addArticle() {
        this.quote.addArticle();
        //met le focus sur l'input about nouvellement insérer
        try {
            setTimeout(()=> {
                let elements = document.getElementById('articles').getElementsByClassName('article-about');
                elements.item(elements.length - 1).getElementsByTagName('input').item(0).focus();
            }, 100);
        } catch (err) {

        }
    }

    save() {
        if (this.quote.save()) {

        } else {
            this.listModal['generalError'] = true;
        }
        //this.quoteService.create(this.quote);
    }

    toBill() {
        const invoice = new InvoiceModel(this.invoiceService);
        invoice.clientPrivateId = this.quote.clientPrivateId;
        invoice.publicId = 'F' + this.quote.publicId.substring(1);
        invoice.where = this.quote.where;
        invoice.whenDay = this.quote.whenDay;
        invoice.whenMonth = this.quote.whenMonth;
        invoice.whenYear = this.quote.whenYear;
        invoice.tva = this.quote.tva;
        invoice.infoClientName = this.quote.infoClientName;
        invoice.infoClientAdress = this.quote.infoClientAdress;
        invoice.articles = this.quote.articles;
        invoice.info = this.quote.info;
        invoice.nbHourWorkForce = this.quote.nbHourWorkForce;
        invoice.priceHourWorkForce = this.quote.priceHourWorkForce;
        invoice.shippingPrice = this.quote.shippingPrice;
        invoice.discount = this.quote.discount;
        invoice.total = this.quote.total;
        invoice.subTotal2 = this.quote.subTotal2;
        invoice.magasin = this.quote.magasin;
        invoice.tvaValue = this.quote.tvaValue;
        invoice.discount2 = this.quote.discount2;
        invoice.useless = this.quote.useless;
        invoice.state = this.quote.state;
        invoice.archive = this.quote.archive;
        this.invoiceService.create(invoice, true);
    }

    returnCustomer() {
        this.router.navigate(['customer', this.customerPrivateId]);
    }

    ngOnDestroy() {

    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/quote/quote.component.ts